import React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';
import { formatDate } from '@common/paymentsUtils/dateUtils';

type ConfirmationPageProps = {
  continueToDashboard: () => void;
  selectedDate: string;
};
class ConfirmationPage extends React.Component<ConfirmationPageProps> {
  static defaultProps = {
    continueToDashboard: () => {},
  };

  render(): React.ReactNode {
    const { selectedDate, continueToDashboard } = this.props;

    return (
      <>
        <SpacerRow>
          <Text type="h3">You&apos;re all set. Here&apos;s what will happen next.</Text>
        </SpacerRow>
        <SpacerRow>
          <Text>We send your tenant a notice of the new rent amount.</Text>
        </SpacerRow>
        <SpacerRow>
          <Text>
            Your tenant then accepts the change before&nbsp;
            <strong>{formatDate(selectedDate, 'MMMM dd, yyyy')}</strong>. (Otherwise, they will continue to pay their
            current rent amount.)
          </Text>
        </SpacerRow>
        <SpacerRow size="md">
          <Button type="primary" full onClick={continueToDashboard}>
            OK, got it
          </Button>
        </SpacerRow>
      </>
    );
  }
}

export default ConfirmationPage;
